import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Snackbar, Alert } from '@mui/material';

const TOAST_ANCHOR_ORIGIN = { vertical: 'top', horizontal: 'right' };

const Toast = ({ open, handleClose, severity, message }) => {
    const severityClassName = severity === 'success' ? 'succ-m' : 'err-m';

    return (
        <Snackbar
            open={open}
            autoHideDuration={2000}
            onClose={handleClose}
            anchorOrigin={TOAST_ANCHOR_ORIGIN}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                className={`toast-alert ${severityClassName}`}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

Toast.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    severity: PropTypes.string,
    message: PropTypes.node,
};

export const useToast = () => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('info');

    const showToast = (severity, message) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleClose = () => {
        setSnackbarOpen(false);
    };

    return {
        ToastComponent: (
            <Toast
                open={snackbarOpen}
                handleClose={handleClose}
                severity={snackbarSeverity}
                message={snackbarMessage}
            />
        ),
        showToast,
    };
};
